export default __webpack_public_path__ + "locales/es/Common.json?hash=dad9618e4d2e8166f4868bf67178dc56";